import Gender from '@/models/Shared/Gender'

export default class GenderViewModel {
    name: string;
    value: Gender;

    public constructor(name: string, value: Gender) {
        this.name = name;
        this.value = value;
    }
}